import { getTableColumns } from "./TableColumns"
import { observer } from "mobx-react"
import { useDeviceListStore, useRootStore } from "contexts/RootStore.context"
import ShowMoreButton from "components/DataTable/components/ShowMoreButton"
import { DataTable } from "components/DataTable/DataTable";
import useDevice from "hooks/useDevice";
import { MobileDataTable } from "components/DataTable/MobileDataTable";
import { MobileRow } from "./MobileRow";
import { useMemo } from "react";
import { Device } from "types/device";

export const DevicesDataTable = observer(() => {

  const {
    deviceList, loading, nextCount, loadDevices, getEmptyListMsg, onSort
  } = useDeviceListStore()
  const { availableFeatures } = useRootStore()
  const { isMobileDevice } = useDevice()

  const SortOptions = useMemo(() => {
    return [
      {
        title: 'Device ID',
        sortField: 'device_id',
      },
      {
        title: 'Last Seen',
        sortField: 'last_update',
        DescTitle: 'descending',
        AscTitle: 'ascending',
      },
      {
        title: 'Location',
        sortField: 'location',
      }
    ]
  }, [])

  return (
    <>
      {isMobileDevice
        ? <MobileDataTable
          loading={loading}
          data={deviceList}
          defaultSortField="last_update"
          defaultSortDirection="desc"
          emptyListMsg={getEmptyListMsg}
          onSort={onSort}
          renderLoadMore={nextCount > 0 && (
            <ShowMoreButton
              fetchFunction={() => loadDevices()}
              nextIsLoading={loading}
              nextCount={nextCount}
            />
          )}
          RowElement={row => <MobileRow device={row} />}
          SortOptions={SortOptions}
        />
        : <DataTable<Device>
          loading={loading}
          columns={getTableColumns(availableFeatures)}
          data={deviceList}
          emptyListMsg={getEmptyListMsg}
          onSort={onSort}
          renderLoadMore={nextCount > 0 && (
            <ShowMoreButton
              fetchFunction={() => loadDevices()}
              nextIsLoading={loading}
              nextCount={nextCount}
            />
          )}
        />
      }
    </>
  )
})